"use strict";

exports.__esModule = true;
exports.FlexTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _FlexRow = require("./FlexRow");
var _excluded = ["width", "height", "rowHeight", "columnGutter", "rowGutter", "rowCount", "columnCount", "renderHeader", "renderCell", "getRowProps"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Renders a (vertically) virtualized table of items.
 */
var FlexTable = exports.FlexTable = /*#__PURE__*/function (_Component) {
  function FlexTable() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.renderRow = function (_ref) {
      var rowIndex = _ref.index,
        style = _ref.style;
      var _this$props = _this.props,
        width = _this$props.width,
        columnCount = _this$props.columnCount,
        renderCell = _this$props.renderCell,
        rowHeight = _this$props.rowHeight,
        columnGutter = _this$props.columnGutter,
        getRowProps = _this$props.getRowProps;
      var cells = [];
      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
        var key = rowIndex + ":" + columnIndex;
        cells.push(renderCell({
          key: key,
          rowIndex: rowIndex,
          columnIndex: columnIndex
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
        key: rowIndex,
        gutter: columnGutter,
        width: width,
        height: rowHeight,
        style: style
      }, getRowProps(rowIndex)), cells);
    };
    return _this;
  }
  _inheritsLoose(FlexTable, _Component);
  var _proto = FlexTable.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      rowHeight = _this$props2.rowHeight,
      columnGutter = _this$props2.columnGutter,
      rowGutter = _this$props2.rowGutter,
      rowCount = _this$props2.rowCount,
      columnCount = _this$props2.columnCount,
      renderHeader = _this$props2.renderHeader,
      renderCell = _this$props2.renderCell,
      getRowProps = _this$props2.getRowProps,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.renderHeaderRow(), /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, _extends({
      width: width,
      height: height - rowHeight,
      itemCount: rowCount,
      itemSize: rowHeight + rowGutter
    }, extra), this.renderRow));
  };
  _proto.renderHeaderRow = function renderHeaderRow() {
    var _this$props3 = this.props,
      width = _this$props3.width,
      columnCount = _this$props3.columnCount,
      renderHeader = _this$props3.renderHeader,
      rowHeight = _this$props3.rowHeight,
      columnGutter = _this$props3.columnGutter,
      getRowProps = _this$props3.getRowProps;
    var cells = [];
    var rowIndex = -1;
    for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
      var key = rowIndex + ":" + columnIndex;
      cells.push(renderHeader({
        key: key,
        rowIndex: rowIndex,
        columnIndex: columnIndex
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
      gutter: columnGutter,
      width: width,
      height: rowHeight
    }, getRowProps(rowIndex)), cells);
  };
  return FlexTable;
}(_react.Component);
FlexTable.defaultProps = {
  columnGutter: 16,
  rowGutter: 16,
  getRowProps: function getRowProps() {
    return {};
  }
};